// src/components/visits/VisitsHeader.jsx
import React from 'react';
import { Search, CalendarRange } from 'lucide-react';
import { useTheme } from '../../theme/ThemeContext';

const VisitsHeader = ({
  search,
  onSearchChange,
  dateFrom,
  dateTo,
  onDateFromChange,
  onDateToChange,
}) => {
  const { theme } = useTheme();

  return (
    <section className="mb-4 flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight text-slate-900 dark:text-slate-50">
          Visits
        </h1>
        <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
          Review guard visits, media, and approvals.
        </p>
      </div>

      <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
        {/* Search */}
        <div className="relative">
          <Search className="pointer-events-none absolute left-3 top-2.5 h-4 w-4 text-slate-400" />
          <input
            type="text"
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Search client, property, guard..."
            className={`w-full rounded-lg border bg-white/80 pl-9 pr-3 py-2 text-sm shadow-sm outline-none transition focus:ring-2 focus:ring-sky-500/70 dark:bg-slate-900/70 dark:border-slate-700 ${
              theme.input
            }`}
          />
        </div>

        {/* Date range */}
        <div className="flex items-center gap-2 rounded-lg border border-slate-200 bg-white/80 px-3 py-2 text-xs shadow-sm dark:border-slate-700 dark:bg-slate-900/70">
          <CalendarRange className="mr-1 h-4 w-4 text-slate-400" />
          <div className="flex items-center gap-2">
            <input
              type="date"
              value={dateFrom}
              onChange={(e) => onDateFromChange(e.target.value)}
              className="rounded-md border border-slate-200 bg-transparent px-2 py-1 text-xs outline-none dark:border-slate-700"
            />
            <span className="text-slate-400">to</span>
            <input
              type="date"
              value={dateTo}
              onChange={(e) => onDateToChange(e.target.value)}
              className="rounded-md border border-slate-200 bg-transparent px-2 py-1 text-xs outline-none dark:border-slate-700"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisitsHeader;
